module.exports = __webpack_public_path__ + "img/left_bg_logn.5b836b26.png";